import { CardSkeleton } from 'components/Skeleton';
import PropTypes from 'prop-types';

const CardListSkeleton = ({ items = 3, className = '', contentLines = 2 }) => {
  return (
    <div className={className}>
      {Array.from({ length: items }, (_, index) => (
        <div key={`skeleton-${index}`} className='mt-5'>
          <CardSkeleton
            showImage={false}
            contentLines={contentLines}
            spacing='sm'
          />
        </div>
      ))}
    </div>
  );
};

CardListSkeleton.propTypes = {
  items: PropTypes.number,
  className: PropTypes.string,
  contentLines: PropTypes.number,
};

export default CardListSkeleton;
